import * as React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import {
  ButtonColorTypes,
  ButtonThemeVariant,
  variants
} from '../Button/Button.types';
import { ISpinnerProps } from './Spinner.types';

type ThemedProps = {
  theme: DefaultTheme;
} & ISpinnerProps;

const getSpinnerColorProp = (prop: keyof ButtonThemeVariant) => ({
  theme,
  buttonType = variants.PRIMARY
}: ThemedProps) => {
  return theme.button[buttonType][prop];
};

// @ts-nocheck
const StyledSpinner = styled.div<{
  size: number;
  show: boolean;
  buttonType?: ButtonColorTypes;
}>`
  height: ${({ size }) => size || 50}px;
  width: ${({ size }) => size || 50}px;
  display: ${({ show }) => (show ? 'block' : 'none')};
  border-radius: 50%;
  font-size: 10px;
  //TODO Add opacity on 3 first borders
  border-top: 2px solid
    ${({ theme, buttonType }) =>
      buttonType ? getSpinnerColorProp('spinnerColor') : theme.colors.font2};
  border-right: 2px solid
    ${({ theme, buttonType }) =>
      buttonType ? getSpinnerColorProp('spinnerColor') : theme.colors.font2};
  border-bottom: 2px solid
    ${({ theme, buttonType }) =>
      buttonType ? getSpinnerColorProp('spinnerColor') : theme.colors.font2};
  border-left: 2px solid ${({ theme }) => theme.colors.font3};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: spinnerRotate 1.1s infinite linear;
  animation: spinnerRotate 1.1s infinite linear;

  .hidden {
    display: none;
  }

  @-webkit-keyframes spinnerRotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spinnerRotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

const Spinner: React.FC<ISpinnerProps> = ({
  show,
  className = '',
  testId,
  size,
  buttonType
}) => {
  return (
    <StyledSpinner
      show={show}
      size={size}
      className={`${className} spinner`}
      data-testid={testId || 'spinner'}
      buttonType={buttonType}
    />
  );
};

export default Spinner;
